import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError, of } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { ToastService } from '../services/toast.service';

export const authenticationInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const toast = inject(ToastService)
  return next(req).pipe(
    catchError(err => {
      console.log('> error in interceptor: ', err)
      if ([401].includes(err.status)) {
        // auto logout if 401 response returned from api
        toast.warn('Authentication Failed', 'Please login, your authentication failed.')
        auth.resetSessionAndRedirectToLogin();
      } else if ([502].includes(err.status)) {
        toast.warn('Bad Gateway Error', 'Network error in connection with the server.')
      } else if ([0].includes(err.status)) {
        toast.warn('Network or Service Error', 'Network error in connection with the server or backend service is down.')
      } else {
        const error = err.error || err.statusText;
        return throwError(() => error);
      }
      const errorResponse = new HttpResponse({ status: err.status, body: { message: err.message, ...err.error } })
      return of(errorResponse);
    })
  )
};
